import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import slide3 from '../aseets/images/home/slide3.jpg';
import { useSettings } from '../contexts/SettingsContext';

const CookiePolicy = () => {
  const { t } = useTranslation();
  const { settings, isLoading } = useSettings();
  
  // Valeur par défaut si les paramètres sont en cours de chargement
  const contactEmail = isLoading ? 'info@medagricycle.eu' : (settings.email || 'info@medagricycle.eu');

  return (
    <>
      <Navbar />
      <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059" style={{
        backgroundImage: `url(${slide3})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}>
        <div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type">
          <div class="jet-theme-core-document__inner">
            <article id="post-4059" class="post-4059 page type-page status-publish hentry">	
              <div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
                <section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-widget_type="jet-slider.default">
                          <div class="elementor-widget-container">
                           
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                
      <div style={{
        minHeight: 'calc(100vh - 200px)',
        padding: '80px 20px 60px',
        maxWidth: '1200px',
        margin: '50px auto',
        fontFamily: 'Inter, sans-serif',
        position: 'relative'
      }}>
  <div style={{ inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                                  <div style={{ background: 'rgba(0,0,0,0.45)', padding: '16px 24px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)', maxWidth: '960px', width: '100%' }}>
                                    <h1 style={{ color: '#fff', fontSize: 'clamp(34px,6vw,56px)', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '0.5px' }}>
            {t('cookiePolicy.title', 'Cookie Policy')}
          </h1>
                                  </div>
                                </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          lineHeight: '1.8',
          color: '#333',
          backdropFilter: 'blur(5px)'
        }}>
         
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('cookiePolicy.whatAreCookies', 'What are Cookies?')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('cookiePolicy.whatAreCookiesText', 'Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the website owners.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('cookiePolicy.howWeUseCookies', 'How We Use Cookies')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('cookiePolicy.howWeUseCookiesText', 'We use cookies to:')}
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px', fontSize: '1.1rem' }}>
              <li style={{ marginBottom: '10px' }}>{t('cookiePolicy.use1', 'Remember your preferences and settings')}</li>
              <li style={{ marginBottom: '10px' }}>{t('cookiePolicy.use2', 'Improve website functionality and user experience')}</li>
              <li style={{ marginBottom: '10px' }}>{t('cookiePolicy.use3', 'Analyze website traffic and usage patterns')}</li>
              <li style={{ marginBottom: '10px' }}>{t('cookiePolicy.use4', 'Provide personalized content')}</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('cookiePolicy.typesOfCookies', 'Types of Cookies We Use')}
            </h2>
            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.4rem', color: '#96ca2d', marginBottom: '15px', fontWeight: 600 }}>
                {t('cookiePolicy.essential', 'Essential Cookies')}
              </h3>
              <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                {t('cookiePolicy.essentialText', 'These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.')}
              </p>
            </div>
            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.4rem', color: '#96ca2d', marginBottom: '15px', fontWeight: 600 }}>
                {t('cookiePolicy.analytics', 'Analytics Cookies')}
              </h3>
              <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                {t('cookiePolicy.analyticsText', 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.')}
              </p>
            </div>
            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.4rem', color: '#96ca2d', marginBottom: '15px', fontWeight: 600 }}>
                {t('cookiePolicy.preferences', 'Preference Cookies')}
              </h3>
              <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                {t('cookiePolicy.preferencesText', 'These cookies allow the website to remember information that changes the way the website behaves or looks, such as your preferred language or region.')}
              </p>
            </div>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('cookiePolicy.manageCookies', 'Managing Cookies')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('cookiePolicy.manageCookiesText', 'You can control and manage cookies in various ways. Please keep in mind that removing or blocking cookies can impact your user experience and parts of our website may no longer be fully accessible.')}
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('cookiePolicy.browserSettings', 'Most browsers allow you to refuse or accept cookies. You can also delete cookies that have already been set. The methods for doing so vary from browser to browser.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('cookiePolicy.contact', 'Contact')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('cookiePolicy.contactText', 'If you have any questions about our use of cookies, please contact us at:')}
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>Email:</strong> {contactEmail}
            </p>
          </section>

          <p style={{ 
            marginTop: '40px', 
            paddingTop: '20px', 
            borderTop: '2px solid #e5e7eb',
            fontSize: '0.9rem',
            color: '#6b7280',
            fontStyle: 'italic'
          }}>
            {t('cookiePolicy.lastUpdated', 'Last updated:')} {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CookiePolicy;

